import { Autocomplete, FormControl, InputLabel, MenuItem, Select, SelectChangeEvent, TextField } from "@mui/material";
import CascateList from "../../../../../../common/components/cascate_list";
import { useCallback } from "react";
import PrimaryButton from "../../../../../../common/components/primary_button";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import DefaultInput from "../../../../../../common/components/default_input";
import { DefaultDatePicker } from "../../../../../../common/components/masked_inputs/default_date_picker_input";

// Header 

type Props = {
  tipoPesquisa: number;
  pesquisa: string | Date | number | null;
  status: number;
  centroDeCustoLista: { id: number, title: string }[];
  centroDeCusto: number[];
  onClearFilters: () => void;
  handleTipoPesquisa: (v: number) => void;
  handlePesquisa: (v: string | Date | number | null) => void;
  handleStatus: (s: number) => void;
  handleCentroDeCusto: (v: number[]) => void;
};


export const Header = ({ tipoPesquisa, pesquisa, status, centroDeCustoLista, centroDeCusto, handlePesquisa, handleStatus, handleTipoPesquisa, onClearFilters, handleCentroDeCusto }: Props) => {
  const handleClearFilters = useCallback(() => {
    onClearFilters();
  }, [onClearFilters]);

  return (
    <CascateList title="Filtros" defaultOpen>
      <div className="w-full flex flex-col gap-6">
        <div className="w-full grid gap-3 grid-cols-1 md:grid-cols-[275px,1fr,220px]">
          <div className="flex gap-1">
            <FormControl size="small" sx={{ width: "275px" }}>
              <InputLabel id="modulo-dashboard" size="small">Pesquisar por</InputLabel>
              <Select
                size="small"
                labelId="modulo-dashboard"
                label="Pesquisar por"
                value={tipoPesquisa}
                onChange={(event: SelectChangeEvent<number>) => {
                  handlePesquisa('');
                  handleTipoPesquisa(event.target.value as number)
                }}>
                <MenuItem value={0}>Numero</MenuItem>
                <MenuItem value={1}>Data</MenuItem>
                <MenuItem value={2}>Evento</MenuItem>
                <MenuItem value={3}>Assunto</MenuItem>
                <MenuItem value={4}>Setor</MenuItem>
              </Select>
            </FormControl>
          </div>
          <div className="w-full">
            {
              (tipoPesquisa === 1) ? (
                <DefaultDatePicker
                  label="Pesquisar"
                  name="search_by_name"
                  value={typeof pesquisa === 'string' ? pesquisa : ''}
                  onChangeValue={(e) => handlePesquisa(e)}
                />
              ) : (tipoPesquisa === 0 || tipoPesquisa === 3 || tipoPesquisa === 2 || tipoPesquisa === 4) ? (
                <DefaultInput
                  label="Pesquisar"
                  name="search_by_name"
                  value={typeof pesquisa === 'string' ? pesquisa : ''}
                  onChangeValue={handlePesquisa}
                />
              ) : (<></>)
            }
          </div>
          <FormControl size="small" sx={{ width: "220px" }}>
            <InputLabel id="status-label" size="small">Status</InputLabel>
            <Select
              size="small"
              labelId="status-label"
              label="Status"
              value={status}
              onChange={(event: SelectChangeEvent<number>) => {
                handleStatus(event.target.value as number)
              }}>
              <MenuItem value={0}>Todas ações</MenuItem>
              <MenuItem value={1}>Aberto</MenuItem>
              <MenuItem value={2}>Fechados</MenuItem>
            </Select>
          </FormControl>
          <FormControl size="small" fullWidth>
            <Autocomplete
              size="small"
              multiple
              options={centroDeCustoLista}
              value={centroDeCustoLista.filter((i) => centroDeCusto.includes(i.id))}
              getOptionLabel={(i) => i.title}
              onChange={(_, newValue) => {
                const selectedIds = newValue.map((i) => i.id);
                handleCentroDeCusto(selectedIds);
              }}
              isOptionEqualToValue={(option, selectedOption) => option.id === selectedOption.id}
              getOptionKey={(x) => x.id}
              filterSelectedOptions
              renderInput={(params) => (
                <TextField
                  {...params}
                  size="small"
                  label="Centro de custo"
                />
              )}
            />
          </FormControl>
          <div className="w-full flex justify-end md:col-span-3">
            <div className="w-full md:w-[180px]">
              <PrimaryButton
                startIcon={<DynamicIcon nameIcon="ClearRounded" size={25} className="text-black" />}
                buttonColor="yellow"
                onClick={handleClearFilters}>
                Limpar filtros
              </PrimaryButton>
            </div>
          </div>

        </div>
      </div>
    </CascateList>
  );
}